import { noEl } from '../core/constants';
import { t_locator } from'../../../pip/library/pi-ip/pi-ip.js';

import f1 from'../../../pip/library/pi-f1/pi-f1.js';

export type TResourceConfiguration = {};

/**
 *
 */
export interface IResource {
  /**
   * Every resource should have a unique, lower-case name
   */
  readonly id: string;

  /**
   * a list of resources to import with `$ip.require` and place in `resources`
   * @see resources
   */
  imports?: t_locator[];

  /**
   * every resource loaded from imports
   * @readonly
   */
  resources?: unknown[];

  /**
   *
   */
  configuration?: TResourceConfiguration;

  /**
   * A resource is provided it's configuration in the initialization phase.
   * This method should:
   *
   * 1. normalize the configuration
   * 2. setup internal memory
   *
   * If you do not apply the configuration internally it will be lost
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initialize?(configuration: TResourceConfiguration, resources?: unknown[]): Promise<this>;

  /**
   * All internal memory should be cleaned
   */
  uninitialize?(): Promise<this>;

  /**
   * afterwards the service is running
   */
  activate?(): Promise<this>;

  /**
   * turn the service off
   */
  deactivate?(): Promise<this>;
}

/**
 * A Service
 */
export class Resource implements IResource {
  /**
   * the singular configuration associated with this service, defined by the
   * sub-type
   */
  configuration: TResourceConfiguration = {} as TResourceConfiguration;

  /**
   *
   */
  host = noEl;

  /**
   * a list of resources to `$ip.require`, the resources will be in `resources`
   * @see Service#resources
   */
  imports = [] as t_locator[];

  /**
   * If there are any `imports`, then after the `import` step, the first step of `startup`
   * this array will have all the resources loaded
   */
  resources = [] as unknown[];

  /**
   * @readonly
   * The unique name of the service within the hub it is connected to
   */
  id: string;

  /**
   * A source is provided it's configuration in the initialization phase.
   * This method should:
   *
   * 1. normalize the configuration
   * 2. setup internal memory
   *
   * If you do not apply the configuration internally it will be lost
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initialize(configuration: TResourceConfiguration, resources?: unknown[]) {
    return f1.done(this);
  }

  /**
   * All internal memory should be cleaned
   */
  uninitialize() {
    return f1.done(this);
  }

  /**
   * After initialization, the service should influence the broader application platform. At this stage, all services are injected
   */
  activate() {
    return f1.done(this);
  }

  /**
   * If the shutdown function is called on the service hub, then the service will deactivate
   * and should not affect the broader system
   */
  deactivate() {
    return f1.done(this);
  }
}
